<template>
  <div>
    <reply v-for="reply in replies"  :key="reply._id"
      :commentId="commentId" :reply="reply" @delete-reply="onDeleteReply"/>
  </div>
</template>
<script>
import { } from 'mdbvue';
import reply from './Reply';
export default {
  name: 'ReplyList',
  components: { reply },
  props: ['commentId', 'replies'],
  methods: {
    onDeleteReply (reply) {
      const ix = this.replies.findIndex(r => r._id === reply._id)
      if (ix !== -1) {
        this.replies.splice(ix, 1)
      }
    }
  }
}
</script>
